import { ColumnsType } from '../../../../core/constants/columnsType';
import { isMobile } from '../../../../core/helpers/isMobile';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { partnerSkinNames } from '../../../../core/constants/partnerSkinEnums';

export const FishingCanvasConfigMobile = {
  backgroundAlpha: 0,
  width: 359,
  height: 364,
};

export const FishingCanvasConfigWeb = {
  backgroundAlpha: 0,
  width: 1027,
  height: 680,
};

export const FishingOddConfigWeb = {
  styles: {
    fontFamily: 'Arial',
    fontSize: 24,
    fill: 0xffffff,
    align: 'center',
    fontWeight: 'bold',
  },
  anchor: 0.5,
  topCX: 585,
  topCY: 380,
  pgX: 515,
  pgY: 350,
};

export const FishingOddConfigMobile = {
  styles: {
    fontFamily: 'Arial',
    fontSize: 30,
    fill: 0xffffff,
    align: 'center',
    fontWeight: 'bold',
  },
  anchor: 0.2,
  topCX: 178,
  topCY: 182,
  pgAnchor: 0.2,
  pgX: 175,
  pgY: 190,
};

export const fishingAnimationSourceNames = {
  fishAnimation: 'fishAnimation',
  background: 'background',
};

export const FISH_ANIMATION_NAMES = {
  Fish: 'fish',
  Idle: 'idle',
  Shark: 'shark',
  bgAnim: 'bg_anim',
};

export const gameResources = (partnerSkin) => {
  const animFileName = partnerSkinNames[partnerSkin];
  const fishingAnimationSourcesWeb = {
    bg_anim: {
      name: fishingAnimationSourceNames.background,
      path: `animations/fishing_${animFileName}/bg_web.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/fishing_${animFileName}/bg_web.atlas`,
        },
      },
    },
    fishAnim: {
      name: fishingAnimationSourceNames.fishAnimation,
      path: `animations/fishing_${animFileName}/fishes_web.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/fishing_${animFileName}/fishes_web.atlas`,
        },
      },
    },
  };

  const fishingAnimationSourcesMobile = {
    bg_anim: {
      name: fishingAnimationSourceNames.background,
      path: `animations/fishing_${animFileName}/bg_mobile.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/fishing_${animFileName}/bg_mobile.atlas`,
        },
      },
    },
    fishAnim: {
      name: fishingAnimationSourceNames.fishAnimation,
      path: `animations/fishing_${animFileName}/fishes_mobile.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/fishing_${animFileName}/fishes_mobile.atlas`,
        },
      },
    },
  };
  return [
    ...Object.values(isMobile() ? fishingAnimationSourcesMobile : fishingAnimationSourcesWeb),
  ];
};

export const SHARK_TYPE = 2;
export const SHARK_SKIN_NAME = isPG() ? '0' : 'shark';

export const fishingCountdownDeductionValues = {
  deductionValue: 0.1,
  intervalDelay: 100,
  precision: 1,
};

export const fishOddByIndex = [
  1, 0.5, 0, 1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.4, 2.6, 2.8, 3, 3.2, 3.4, 3.6, 3.8, 4, 4.2, 4.4, 4.8, 5,
];

export const FISHING_GAME_ID = 49;

export const DURATION_FROM_FISH = 5.5;

export const FishingLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'default',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: (spinInfo) => `≈ ${spinInfo.odd}x`,
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FishingBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'roundId',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({
            name: PopupTypes.Fairness,
            spinInfo: {
              ...spinInfo,
              openedFishes: spinInfo.roundData,
              id: spinInfo.roundId,
              startedDate: spinInfo.date,
            },
          });
          checkHashStore.setSpinInfo({
            salt: spinInfo.resultSalt,
            key: spinInfo.resultKey,
            hash: spinInfo.resultHash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'default',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: (spinInfo) => `≈ ${spinInfo.odd}x`,
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FISHING_ABOUT_HASH_KEYS = new Array(18).fill(null).map((item, index) => index + 1);
export const FISHING_RULE_KEYS_FIRST = new Array(isPG() ? 13 : 9)
  .fill(null)
  .map((item, index) => index + 1);
